/* Chula — navigation overlay
 *
 * Extracted from snippets/chula-shop-overlay.liquid on 2026-09-20.
 *
 * It was an inline <script> in the page body: re-sent and re-parsed on EVERY
 * page, never cached. As a theme asset it is fetched once and cached for the
 * session, and `defer` keeps it off the parser's critical path. The code is
 * the inline block verbatim, with Liquid comments turned into JS ones.
 */

(() => {
    if (window.chulaShopOverlayInit) return;
    window.chulaShopOverlayInit = true;

    const overlay = document.querySelector('[data-chula-shop-overlay]');
    if (!overlay) return;

    document.body.appendChild(overlay);

    const grid = overlay.querySelector('[data-chula-grid]');
    const split = overlay.querySelector('[data-chula-split]');
    const splitLinks = overlay.querySelector('[data-chula-split-links]');
    const splitTiles = overlay.querySelector('[data-chula-split-tiles]');
    const archives = overlay.querySelector('[data-chula-archives]');
    const archivesList = overlay.querySelector('[data-chula-archives-list]');
    const archivesChildren = overlay.querySelector('[data-chula-archives-children]');
    const archivesGrid = overlay.querySelector('[data-chula-archives-grid]');

    const replayTiles = () => {
      overlay.querySelectorAll('.chula-shop-overlay__tile').forEach((tile) => {
        tile.style.animation = 'none';
        void tile.offsetWidth;
        tile.style.animation = '';
      });
    };

    /* The images a trigger carries, stamped by header.liquid from the
       matched mega_menu block. Reading them off the trigger is what lets
       ANY menu item use these views — the old code could only ever show
       Shop's four tiles and Our Story's one image, because both were
       baked into this file's own markup from two named blocks. */
    function triggerImages(el) {
      if (!el) return [];
      try { return JSON.parse(el.getAttribute('data-chula-overlay-images') || '[]'); }
      catch (e) { return []; }
    }

    const openShop = (trigger) => {
      const images = triggerImages(trigger);
      /* Only repaint when the trigger actually declares images; otherwise
         keep the server-rendered tiles already in the grid. */
      if (images.length) {
        while (grid.firstChild) grid.removeChild(grid.firstChild);
        images.forEach((img) => {
          const a = document.createElement('a');
          a.className = 'chula-shop-overlay__tile';
          a.href = img.link || '#';
          const im = document.createElement('img');
          im.src = img.src;
          im.alt = '';
          a.appendChild(im);
          if (img.heading) {
            const span = document.createElement('span');
            span.className = 'chula-shop-overlay__caption';
            span.textContent = img.heading;
            a.appendChild(span);
          }
          grid.appendChild(a);
        });
      }
      grid.hidden = false;
      split.hidden = true;
      archives.hidden = true;
      showOverlay();
      replayTiles();
    };

    function addTile(container, src, heading, link) {
      if (!src) return;
      const a = document.createElement('a');
      a.className = 'chula-shop-overlay__tile';
      a.href = link || '#';
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      a.appendChild(img);
      if (heading) {
        const span = document.createElement('span');
        span.className = 'chula-shop-overlay__caption';
        span.textContent = heading;
        a.appendChild(span);
      }
      container.appendChild(a);
    }

    function syncTilesWidth() {
      splitTiles.classList.toggle('chula-shop-overlay__tiles--single', splitTiles.children.length === 1);
    }

    function makeBackButton(title, onClick) {
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'chula-shop-overlay__back';
      back.innerHTML = '<svg width="9" height="16" viewBox="0 0 9 16" fill="none" aria-hidden="true"><path d="M8 1L1 8L8 15" stroke="currentColor" stroke-width="1.2"/></svg>';
      const span = document.createElement('span');
      span.textContent = title;
      back.appendChild(span);
      back.addEventListener('click', onClick);
      return back;
    }

    // Renders a sub-link's own drill-in view: back row (names the panel
    // itself, not its parent), its child links (plus an "Explore X" link to
    // its own page, if it has one), and its own matched image set — reads
    // the JSON payload chula-submenu-panel-style .mega-menu markup embeds
    // in data-csp-drill (see mega-menu.liquid).
    function renderDrilled(payload, details, trigger) {
      while (splitLinks.firstChild) splitLinks.removeChild(splitLinks.firstChild);
      while (splitTiles.firstChild) splitTiles.removeChild(splitTiles.firstChild);
      splitLinks.classList.add('chula-shop-overlay__links--drilled');

      splitLinks.appendChild(makeBackButton(payload.title, () => renderTopLevel(details, trigger)));

      if (payload.url && payload.url !== '#') {
        const exploreLink = document.createElement('a');
        exploreLink.href = payload.url;
        exploreLink.textContent = (overlay.dataset.exploreLabel || 'Explore {title}').replace('{title}', payload.title);
        splitLinks.appendChild(exploreLink);
      }

      (payload.links || []).forEach((child) => {
        const a = document.createElement('a');
        a.href = child.url;
        a.textContent = child.title;
        splitLinks.appendChild(a);
      });

      (payload.images || []).forEach((img) => addTile(splitTiles, img.src, img.heading, img.link));

      syncTilesWidth();
      replayTiles();
    }

    // Renders the normal top-level view for a Shop/Our Story/Archives
    // click — a flat, deduped list of that item's links (any sub-link
    // carrying a data-csp-drill payload becomes a button that drills in
    // instead of navigating) plus its single default image.
    function renderTopLevel(details, trigger) {
      while (splitLinks.firstChild) splitLinks.removeChild(splitLinks.firstChild);
      while (splitTiles.firstChild) splitTiles.removeChild(splitTiles.firstChild);
      splitLinks.classList.remove('chula-shop-overlay__links--drilled');

      const seen = {};
      details.querySelectorAll('.mega-menu__linklist a, .header__dropdown-menu a').forEach((link) => {
        const title = (link.textContent || '').trim();
        const href = link.getAttribute('href') || '#';
        if (!title || seen[title]) return;
        seen[title] = true;

        const drillRaw = link.getAttribute('data-csp-drill');
        let payload = null;
        if (drillRaw) {
          try { payload = JSON.parse(drillRaw); } catch (e) { payload = null; }
        }

        if (payload) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'chula-shop-overlay__link-trigger';
          button.textContent = title;
          button.addEventListener('click', () => renderDrilled(payload, details, trigger));
          splitLinks.appendChild(button);
        } else {
          const a = document.createElement('a');
          a.href = href;
          a.textContent = title;
          splitLinks.appendChild(a);
        }
      });

      /* One editorial image beside the links. Taken from the trigger's own
         block (image 1), falling back to the legacy data-story-* attributes
         on the wrapper so an untouched "Automatic" Our Story block still
         paints exactly as before. */
      const images = triggerImages(trigger);
      if (images.length) {
        images.forEach((img) => addTile(splitTiles, img.src, img.heading, img.link));
      } else {
        addTile(splitTiles, overlay.dataset.storyImage, overlay.dataset.storyHeading, overlay.dataset.storyLink);
      }
      syncTilesWidth();
      replayTiles();
    }

    const openSplit = (details, trigger) => {
      grid.hidden = true;
      split.hidden = false;
      archives.hidden = true;
      renderTopLevel(details, trigger);
      showOverlay();
    };

    /* A collapse in flight, so an expand — or a fresh list render — can
       cancel its teardown. Left to run, it would empty a panel that has
       since been re-populated. */
    let archivesCollapseEnd = null;

    function cancelArchivesCollapse() {
      if (!archivesCollapseEnd) return;
      archives.removeEventListener('transitionend', archivesCollapseEnd.onEnd);
      clearTimeout(archivesCollapseEnd.timer);
      archivesCollapseEnd = null;
    }

    // Archives-only view (see "Menu 1" / "Menu 2" references): starts as
    // just the link list (Menu 1) at the panel's narrow default width: a
    // persistent list that never gets replaced, only its active item
    // changes. Clicking an item with children widens the panel and slides
    // in a children column + matching image grid next to it (Menu 2) —
    // reusing the same data-csp-drill payload chula-submenu-panel-style
    // .mega-menu markup already embeds (see mega-menu.liquid). No back
    // button anywhere in this view — only the overlay's own close X.
    function expandArchivesChild(row, payload) {
      cancelArchivesCollapse();

      archivesList.querySelectorAll('.chula-shop-overlay__archives-item').forEach((el) => {
        el.classList.remove('is-active');
        if (el.tagName === 'BUTTON') el.setAttribute('aria-expanded', 'false');
      });
      row.classList.add('is-active');
      row.setAttribute('aria-expanded', 'true');

      archivesChildren.classList.remove('is-open');
      archivesGrid.classList.remove('is-open');
      while (archivesChildren.firstChild) archivesChildren.removeChild(archivesChildren.firstChild);
      while (archivesGrid.firstChild) archivesGrid.removeChild(archivesGrid.firstChild);

      (payload.links || []).forEach((child) => {
        const a = document.createElement('a');
        a.href = child.url;
        a.textContent = child.title;
        archivesChildren.appendChild(a);
      });

      const images = payload.images || [];
      archivesGrid.dataset.count = String(images.length);
      images.forEach((img) => addTile(archivesGrid, img.src, img.heading, img.link));

      archivesChildren.hidden = false;
      archivesGrid.hidden = false;
      archives.classList.add('is-expanded');
      replayTiles();

      /* Forced reflow, not requestAnimationFrame. rAF does not run in a
         throttled or background tab, and the two columns rest at opacity 0
         — so the callback that reveals them never fired and the panel
         widened onto nothing. Reading offsetHeight flushes layout from the
         just-unhidden state, which is all the transition needs to have
         somewhere to start from. The flat branch below already does this,
         and says so; this one was the exception. */
      void archivesChildren.offsetHeight;
      archivesChildren.classList.add('is-open');
      archivesGrid.classList.add('is-open');
    }

    /* ── Clicking the open row again closes it ─────────────────────────
       The inverse of expandArchivesChild, on the same control: the row
       that widened the panel retracts it. Everything runs backwards — the
       children column and the image grid fade and slide out, the container
       narrows to the list alone — and the columns only leave the flow and
       give up their contents once the width transition has finished.
       Emptying them up front would make them vanish rather than retract,
       which is the whole difference between a collapse and a cut.

       Teardown hangs off `transitionend` rather than a fixed timer: a
       timer in a throttled tab fires late or coalesced, leaving invisible
       columns holding their space. Under prefers-reduced-motion the CSS
       kills the transition outright and no event is ever dispatched, so
       that case is read off the computed duration and finished on the
       spot. The timer that remains is a fallback for an interrupted
       transition, not the mechanism.

       Only a row that is `is-active` may reach here (see the click
       handler). That matters: the --flat variant also sets `is-expanded`,
       but it has no active row and no drill payload, so no row there
       carries a click handler at all and this can never strip it. */
    function collapseArchivesChild(row) {
      cancelArchivesCollapse();

      row.classList.remove('is-active');
      row.setAttribute('aria-expanded', 'false');

      archivesChildren.classList.remove('is-open');
      archivesGrid.classList.remove('is-open');
      archives.classList.remove('is-expanded');

      const finish = () => {
        cancelArchivesCollapse();
        archivesChildren.hidden = true;
        archivesGrid.hidden = true;
        while (archivesChildren.firstChild) archivesChildren.removeChild(archivesChildren.firstChild);
        while (archivesGrid.firstChild) archivesGrid.removeChild(archivesGrid.firstChild);
        archivesGrid.removeAttribute('data-count');
      };

      if (!parseFloat(getComputedStyle(archives).transitionDuration)) {
        finish();
        return;
      }

      const onEnd = (event) => {
        /* The columns' own opacity/transform transitions bubble to this
           same element — only the container's width means it is over. */
        if (event.target === archives && event.propertyName === 'width') finish();
      };

      archivesCollapseEnd = { onEnd: onEnd, timer: setTimeout(finish, 1200) };
      archives.addEventListener('transitionend', onEnd);
    }

    function renderArchivesList(details, trigger) {
      cancelArchivesCollapse();
      while (archivesList.firstChild) archivesList.removeChild(archivesList.firstChild);
      archives.classList.remove('is-expanded');
      archives.classList.remove('chula-shop-overlay__archives--flat');
      archivesChildren.classList.remove('is-open');
      archivesGrid.classList.remove('is-open');
      archivesChildren.hidden = true;
      archivesGrid.hidden = true;
      while (archivesChildren.firstChild) archivesChildren.removeChild(archivesChildren.firstChild);
      while (archivesGrid.firstChild) archivesGrid.removeChild(archivesGrid.firstChild);

      const seen = {};
      details.querySelectorAll('.mega-menu__linklist a, .header__dropdown-menu a').forEach((link) => {
        const title = (link.textContent || '').trim();
        const href = link.getAttribute('href') || '#';
        if (!title || seen[title]) return;
        seen[title] = true;

        const drillRaw = link.getAttribute('data-csp-drill');
        let payload = null;
        if (drillRaw) {
          try { payload = JSON.parse(drillRaw); } catch (e) { payload = null; }
        }

        const row = document.createElement(payload ? 'button' : 'a');
        row.className = 'chula-shop-overlay__archives-item';
        if (payload) row.type = 'button';
        else row.href = href;

        const rowLabel = document.createElement('span');
        rowLabel.textContent = title;
        row.appendChild(rowLabel);

        if (payload) {
          const chevron = document.createElement('span');
          chevron.className = 'chula-shop-overlay__archives-chevron';
          chevron.innerHTML = '<svg width="7" height="11" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.2"/></svg>';
          row.appendChild(chevron);
          row.setAttribute('aria-expanded', 'false');
          row.addEventListener('click', () => {
            if (row.classList.contains('is-active')) collapseArchivesChild(row);
            else expandArchivesChild(row, payload);
          });
        }

        archivesList.appendChild(row);
      });

      /* ── A list with nothing to drill into shows its picture at once ──
         Archives earns its two steps: every item there has children, so the
         panel opens narrow and widens when you choose one. Client services
         has six destinations and no second level, so there is no step to
         take — waiting for a click that reveals nothing would be a gesture
         performed on an empty promise.

         So: if no row in this list has a drill payload, and the trigger's
         block carries at least one image, the panel opens in its expanded
         state with the images already in place. The children column stays
         hidden (its own [hidden] rule takes it out of the flex flow), and
         the --flat width keeps the card proportionate to two columns.

         No requestAnimationFrame — a forced reflow, so the transition still
         runs from the collapsed state in a throttled or background tab.
         This is the rule this file already carries three times over. */
      const flatImages = details.querySelector('[data-csp-drill]') ? [] : triggerImages(trigger);

      if (flatImages.length) {
        archivesGrid.dataset.count = String(flatImages.length);
        flatImages.forEach((img) => addTile(archivesGrid, img.src, img.heading, img.link));
        archivesGrid.hidden = false;
        archives.classList.add('chula-shop-overlay__archives--flat');
        void archivesGrid.offsetHeight;
        archives.classList.add('is-expanded');
        archivesGrid.classList.add('is-open');
      }
    }

    const openArchives = (details, trigger) => {
      grid.hidden = true;
      split.hidden = true;
      archives.hidden = false;
      renderArchivesList(details, trigger);
      showOverlay();
    };

    /* The nav <summary> that opened the overlay, so focus can go back to it.
       Set by the trigger handler below, cleared on close. */
    let overlayOpener = null;

    const showOverlay = () => {
      overlay.hidden = false;
      window.chulaLockHeader && window.chulaLockHeader(true);
      replayTiles();
      if (window.chulaFocusTrap) window.chulaFocusTrap.activate(overlay, overlayOpener);
    };

    const close = () => {
      if (window.chulaFocusTrap) window.chulaFocusTrap.release(overlay);
      overlayOpener = null;
      overlay.hidden = true;
      window.chulaLockHeader && window.chulaLockHeader(false);
    };

    overlay.querySelectorAll('[data-chula-shop-close]').forEach((el) =>
      el.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    /* ── Which overlay opens, and why it is no longer read off the label ──
       This used to be `MENUS = { 'SHOP', 'OUR STORY', 'ARCHIVES' }` matched
       against the trigger's uppercased text. That key fails twice over:

         · a rename breaks it silently — "Our Story" was renamed to
           "Heritage" in the navigation, so the overlay stopped binding to
           it and the item fell back to Prestige's plain dropdown; and
         · `link.title` is TRANSLATED per locale, so on any non-English
           market none of the three matched and none of the overlays opened.
           That is the "menus are not the same across regions" report.

       header.liquid now states the style on the trigger itself
       (`data-chula-overlay`), from the matched mega_menu block's own
       Overlay style setting — text the shopper never sees and translation
       never touches. Items left on "Automatic" (and items with no block at
       all) are resolved from structure instead; see styleFor below.

       Note the upstream half of the regional bug is NOT fixed here and
       cannot be: header.liquid matches a mega_menu block to a nav item by
       comparing `block.settings.menu_item` to `link.title`, so in a locale
       where the navigation is translated but the block setting is not, no
       block matches and no mega-menu is rendered at all — there is nothing
       for this overlay to bind to. That one is a translation task on the
       header block settings, not a code change. */
    /* ── Resolving `auto` from STRUCTURE, not from the label ──────────
       An explicit Overlay style on the block always wins. Everything else
       is read off what the menu actually contains, so a menu gets the right
       panel with no setting to fill in and nothing to keep in sync:

         · a sub-link carrying its own children (a data-csp-drill payload)
           means there is a second level to walk into  -> archives
         · several images on the block means the menu IS the images
           (Shop's four collection tiles)              -> grid
         · anything else is a list of places to go with one editorial
           picture beside it                           -> split

       This is why Heritage works with no customizer change at all. It has
       no mega_menu block, so Prestige renders it as a plain
       .header__dropdown-menu rather than a .mega-menu — renderTopLevel
       already reads both — and with no images and no drill payload it
       resolves to `split`, taking its editorial image from the legacy
       data-story-* fallback. The old code could not reach it because it
       matched the literal string 'OUR STORY' and the item had been renamed. */
    /* ── An item with NO mega_menu block does not open this overlay ───
       Added 2026-09-18, when "Client services" was given children (Delivery
       & Returns, Size Guide, Care Guide, Made to Measure, FAQ, Contact Us).
       With no block of its own it resolved to `split`, and split wants one
       editorial photograph beside the list — which it took from the legacy
       `data-story-*` fallback, which reads a block named "Our Story", which
       no longer exists in this navigation. The result on the storefront was
       a full-height white card with six links in the top corner and nothing
       else: the emptiest screen on the site.

       The structural resolution below is kept for items that DO have a
       block and are left on "Automatic". What changed is the entry
       condition: no block, no overlay. Prestige's own hairline dropdown
       renders instead — which is the right object for a utility menu
       anyway. Services are tasks, not a place to browse; the reference
       houses list them and move on, and a photograph next to "Size Guide"
       would be decoration with nothing to say.

       To give such an item the full overlay later, add a mega_menu block in
       the theme editor with its exact label and pick an Overlay style. The
       old behaviour was written for "Heritage", a top-level item that has
       since left the navigation; every top-level item today except Client
       services has a block. */
    function styleFor(el) {
      const declared = el.getAttribute('data-chula-overlay');
      if (!declared) return null;
      if (declared !== 'auto') return declared;

      const details = el.closest('details');
      if (!details) return null;

      if (details.querySelector('[data-csp-drill]')) return 'archives';
      return triggerImages(el).length > 1 ? 'grid' : 'split';
    }

    /* Only TOP-LEVEL primary-nav items. The old selector swept every
       summary and every nav anchor in the header, which was harmless only
       because just three hardcoded labels ever matched; now that any item
       with children qualifies, a nested sub-menu summary would bind too and
       open the overlay on top of itself. */
    const bindTrigger = () => {
      document.querySelectorAll('.header__primary-nav > ul > li').forEach((li) => {
        const el = li.querySelector('summary');
        if (!el || el.closest('li') !== li) return;

        const style = styleFor(el);
        if (!style) return;

        const details = el.closest('details');
        if (details) details.classList.add('chula-shop-trigger');
        if (el.dataset.chulaShopBound) return;
        el.dataset.chulaShopBound = 'true';
        el.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (details) details.removeAttribute('open');
          overlayOpener = el;
          if (style === 'grid') openShop(el);
          else if (style === 'archives') { if (details) openArchives(details, el); }
          else if (details) openSplit(details, el);
        });
      });
    };

    bindTrigger();
    document.addEventListener('shopify:section:load', bindTrigger);
  })();
